import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
class RoleGuardSevice {
    constructor(private router: Router) { }

    isUserValid(route: ActivatedRouteSnapshot) {
        let roles: any[] = JSON.parse(sessionStorage.getItem('userRoles') ?? '[]');
        let userIsActive = sessionStorage.getItem("userIsActive") ?? '';
        let isUserValid = userIsActive == "true" && roles.some((role: string) => route.data['roles'].includes(role));
        if (!isUserValid) {
            // this.router.navigate(['invalid-permission']);
        }
        return isUserValid;
    }

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Promise<boolean> {
        return await this.isUserValid(route);
    }
}

export const RoleAuthGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
    await inject(RoleGuardSevice).canActivate(route, state);

